import * as api from '../../api'
import * as a9 from '../../analytics'
import theme from '../../theme'
import { Modal, SearchBar, ArticlesList } from '../components'
import type { Article, NavigationItemWithArticles } from '../../types/domain'
import { NavigationItem } from '../../types/model'
import useFetchReducer from '../useFetchReducer'
import { openArticle } from './common'
import type { UUID } from 'crypto'

const styles = {
  modal: {
    '--modal-bckg-color': theme.palette.neutral.lightest,
  },
  searchBar: {
    mt: 1,
    maxWidth: 'var(--content-M-max-width)',
    mx: 'auto',
  },
  articlesList: {
    mt: 1,
  },
}

interface SearchParams extends a9.BaseParams {
  text: string
}

interface SearchProps {
  open: boolean
  onClose: () => void
  mediaProviderId: UUID
}

const Search = ({ open, onClose, mediaProviderId }: SearchProps) => {
  const [results, fetchResults, resetResults] = useFetchReducer<
    Article[] | null
  >(api.getArticlesSearchResults)

  const handleOpenArticle = (article: Article) => {
    const evParams = {
      name: NavigationItem.Search as NavigationItemWithArticles,
      destinationArticleId: article.articleId,
      destinationMediaId: article.mediaProviderId,
    }
    openArticle(article.url, evParams)
  }

  const handleSearch = async (ev: React.FormEvent<HTMLFormElement>) => {
    ev.preventDefault()

    const formValues = Object.fromEntries(
      new FormData(ev.target as HTMLFormElement),
    )
    const searchInputValue = formValues.search

    if (searchInputValue !== '') {
      a9.dispatchEvent(a9.Event.SEARCH, {
        text: searchInputValue,
      } as SearchParams)
    }

    fetchResults(searchInputValue, mediaProviderId)
  }

  const handleCloseModal = () => {
    resetResults()
    onClose()
  }

  if (open === false) return null
  return (
    <Modal
      open={true}
      onClose={handleCloseModal}
      renderInHeader={() => (
        <SearchBar sx={styles.searchBar} onSubmit={handleSearch} />
      )}
      sx={styles.modal}
    >
      {!results.isLoading && results.data === undefined ? null : (
        <ArticlesList
          isFetching={results.isLoading}
          articles={results.data as Article[]}
          error={results.error}
          onClickArticle={handleOpenArticle}
          name={NavigationItem.Search}
          sx={styles.articlesList}
          isCompact
        />
      )}
    </Modal>
  )
}

export default Search
